import React, { useState } from 'react';
import HeroSection from './components/HeroSection';
import ProductSection from './components/ProductSection';
import BenefitsSection from './components/BenefitsSection';
import PricingSection from './components/PricingSection';
import Footer from './components/Footer';
import { useGTM } from './components/GTM';
import { CheckoutModal } from './components/CheckoutModal';

function App() {
  // Inicializar GTM
  useGTM();
  
  // Estado do modal de checkout
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Função para abrir modal
  const openCheckoutModal = () => {
    setIsModalOpen(true);
  };

  // Função para fechar modal
  const closeCheckoutModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="min-h-screen">
      <HeroSection onOpenModal={openCheckoutModal} />
      <ProductSection onOpenModal={openCheckoutModal} />
      <BenefitsSection />
      <PricingSection onOpenModal={openCheckoutModal} />
      <Footer />
      
      {/* Modal de Checkout */}
      <CheckoutModal 
        isOpen={isModalOpen}
        onClose={closeCheckoutModal}
      />
    </div>
  );
}

export default App;
